import { useAppSelector } from '../../redux'

export const useMailman = () => {
  const { _id } = useAppSelector((state) => state.user)

  const mailman = async (endpoint: string, method: 'GET' | 'POST' | 'PUT' | 'DELETE' = 'GET', body?: Object) => {
    const PORT = process.env.PORT || 2053
    // const store = localStorage.getItem('persist:homie-store') || ''
    // let userId = ''
  
    // if (store) {
    //   const parsedStore = JSON.parse(store)
    //   const user = JSON.parse(parsedStore.user)
    //   userId = user._id
    // }
  
    const fetchConfig = {
      method: method,
      headers: { 
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'User-Id': _id
      },
      body: JSON.stringify(body),
      credentials: 'include' as any
    }
  
    // const url = `${window.location.protocol}//${window.location.hostname}:${PORT}/api/${endpoint}`
    const url = process.env.REACT_APP_ENVIRONMENT === 'DEVELOPMENT' ? `${process.env.REACT_APP_SERVER_URL}:${PORT}/api/${endpoint}` : `${process.env.REACT_APP_SERVER_URL}/api/${endpoint}`
  
    const response = await fetch(url, fetchConfig)
    
    if (!response.ok) {
      throw new Error(await response.text())
    }
  
    try {
      return await response.json()
    }
    catch (err) {
      return undefined
    }
  }
  
  return {
    mailman
  }
}